@if (isVisible()) {
  <div class="company-switcher">
    <!-- Trigger: interactive only when more than one company is available. -->
    @if (canSwitch()) {
      <button
        type="button"
        class="company-switcher-trigger"
        (click)="toggleDropdown()"
        [attr.aria-expanded]="isOpen()"
        aria-haspopup="listbox"
        [attr.aria-label]="'Switch company. Current company: ' + activeCompanyName()"
      >
        <i class="hgi hgi-stroke hgi-rounded hgi-building-03 company-icon"></i>
        <span class="company-name">{{ activeCompanyName() }}</span>
        <i class="fa-solid fa-chevron-down caret" [class.open]="isOpen()"></i>
      </button>
    } @else {
      <!-- Single company, or a role that cannot switch: a plain, inert label. -->
      <div class="company-switcher-static">
        <i class="hgi hgi-stroke hgi-rounded hgi-building-03 company-icon"></i>
        <span class="company-name">{{ activeCompanyName() }}</span>
      </div>
    }

    @if (isOpen()) {
      <div
        class="company-switcher-panel"
        role="listbox"
        aria-label="Available companies"
        (keydown)="onPanelKeydown($event)"
      >
        <div class="panel-search">
          <i class="hgi hgi-stroke hgi-rounded hgi-search-01 search-icon"></i>
          <input
            type="text"
            class="search-input"
            placeholder="Search company..."
            [ngModel]="searchTerm()"
            (ngModelChange)="onSearchChange($event)"
            aria-label="Search companies"
          />
        </div>

        @if (isLoading()) {
          <div class="panel-loading">
            @for (row of [1, 2, 3]; track row) {
              <div class="loading-row">
                <app-skeleton shape="circle" width="32px" height="32px"></app-skeleton>
                <div class="loading-text">
                  <app-skeleton width="120px" height="12px"></app-skeleton>
                  <app-skeleton width="80px" height="10px"></app-skeleton>
                </div>
              </div>
            }
          </div>
        } @else if (hasError()) {
          <div class="panel-message panel-error">
            <p>Could not load companies.</p>
            <button type="button" class="retry-btn" (click)="retry()">Retry</button>
          </div>
        } @else if (isEmpty()) {
          <div class="panel-message">
            <p>No companies assigned — contact your administrator.</p>
          </div>
        } @else if (filteredCompanies().length === 0) {
          <div class="panel-message">
            <p>No companies match your search.</p>
          </div>
        } @else {
          <ul class="company-list">
            @for (company of filteredCompanies(); track company.id) {
              <li
                class="company-row"
                role="option"
                [attr.aria-selected]="isActive(company)"
                [class.active]="isActive(company)"
                [class.highlighted]="isHighlighted(company)"
                [class.deactivated]="isDeactivated(company)"
                [attr.tabindex]="isDeactivated(company) ? -1 : 0"
                (click)="selectCompany(company)"
                (keydown.enter)="selectCompany(company)"
                (keydown.space)="selectCompany(company)"
              >
                <div class="company-logo">
                  @if (company.logoUrl) {
                    <img [src]="company.logoUrl" [alt]="company.company_name" />
                  } @else {
                    <span class="logo-fallback">{{ initialOf(company) }}</span>
                  }
                </div>

                <div class="company-info">
                  <span class="row-name">{{ company.company_name }}</span>
                  @if (formatLocation(company)) {
                    <span class="row-location">{{ formatLocation(company) }}</span>
                  }
                </div>

                @if (isDeactivated(company)) {
                  <span class="row-badge">Deactivated</span>
                } @else if (isActive(company)) {
                  <i class="fa-solid fa-check row-check" aria-hidden="true"></i>
                }
              </li>
            }
          </ul>
        }
      </div>
    }
  </div>
}
